import { Tag } from '@crehana/compass.ui/v3/tag';

import type { TimeAttendanceMarkStatus } from '@/generated/graphql/types';

import { STATUS_TAG_CUSTOM_CLASS, STATUS_TAG_VARIANT } from '../constants';
import { useTranslation } from '../i18n';
import { formatMarkTime } from '../utils';

type TDisplayMode = 'received' | 'time-with-status' | 'time-only';

type TStatusTagProps = {
  status: TimeAttendanceMarkStatus;
  markedAt: string;
  timeZone: string;
  displayMode?: TDisplayMode;
};

export const StatusTag = ({
  status,
  markedAt,
  timeZone,
  displayMode = 'time-with-status',
}: TStatusTagProps) => {
  const { t } = useTranslation();
  const formattedTime = formatMarkTime(markedAt, timeZone);

  if (displayMode === 'received') {
    return (
      <span className="tw-cds-font-body-01 tw-cds-text-secondary">
        {t('registro_recibido')}
      </span>
    );
  }

  if (displayMode === 'time-only') {
    return (
      <span className="tw-cds-font-body-01 tw-cds-text-primary">
        {formattedTime}
      </span>
    );
  }

  const variant = STATUS_TAG_VARIANT[status];
  const customClass = STATUS_TAG_CUSTOM_CLASS[status];

  return (
    <Tag
      variant={variant as 'success' | 'pending' | 'warning' | 'info' | 'alert'}
      className={`${customClass} tw-w-8.8`}
    >
      {formattedTime}
    </Tag>
  );
};
